var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
    fill: "#045694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0799 7.77181C17.6396 7.92163 18.0794 8.36146 18.2293 8.92114C18.5 9.93456 18.5 12.0502 18.5 12.0502C18.5 12.0502 18.5 14.1659 18.2282 15.1793C18.0784 15.739 17.6385 16.1788 17.0789 16.3286C16.0654 16.6004 12 16.6004 12 16.6004C12 16.6004 7.93456 16.6004 6.92114 16.3286C6.36146 16.1788 5.92163 15.739 5.77181 15.1793C5.5 14.1659 5.5 12.0502 5.5 12.0502C5.5 12.0502 5.5 9.93456 5.77181 8.92114C5.92163 8.36146 6.36146 7.92163 6.92114 7.77181C7.93456 7.5 12 7.5 12 7.5C12 7.5 16.0654 7.5 17.0799 7.77181ZM14.078 12.0503L10.6996 10.1005V14.0001L14.078 12.0503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhYoutube);
export default __webpack_public_path__ + "static/media/fmh-youtube.fc6827b701f298bbcf0c0c75898a6f1d.svg";
export { ForwardRef as ReactComponent };